import React, { useState, useEffect, useRef } from "react";
import { Disclosure } from "@headlessui/react";

import { MenuIcon, XIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { Link, useNavigate } from "react-router-dom";
import orglogo from "../assests/clogonew.png";
// import swal from "sweetalert";

export default function Header() {
  const [resdata, setResdata] = useState([]);
  const navigate = useNavigate();
  const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false);
  const [openCategories, setOpenCategories] = useState({});
  const menuRef = useRef(null);

  // Toggle "Services" menu in desktop view
  const toggleServicesMenu = () => {
    setIsServicesMenuOpen(!isServicesMenuOpen);
  };

  // Close "Services" menu
  const closeServicesMenu = () => {
    setIsServicesMenuOpen(false);
  };

  // Toggle category submenus
  const toggleCategory = (categoryName) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  // Scroll to top when navigating
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Navigate to the booking form and scroll to top
  const bookingForm = () => {
    navigate("/mapform");
    scrollToTop();
  };

  const paymentGateway = () => {
    navigate("/paymentgateway");
    // swal('This feature is comming soon!');
    scrollToTop();
  };

  // Close the "Services" dropdown if clicked outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeServicesMenu();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  // Fetch services dynamically

  const navigation = [
    { name: "Home", href: "/LandingPage", current: false },
    { name: "Why Choose Us", href: "/about_us", current: false },
    { name: "About us", href: "/about_us", current: false },
    {
      name: " Services & Services",
      href: "#",
      current: false,
      children: [
        {
          name: "Appliances",
          href: "#",
          current: false,
          children: [
            {
              name: "AC Installation",
              href: "/newplumbingwork",
              current: false,
            },
            { name: "AC Repair", href: "/newplumbingwork", current: false },
            { name: "Cooler", href: "/coolerservices", current: false },
            { name: "Washing machine", href: "/mapform", current: false },

            { name: "Refrigerator", href: "/fridgeservices", current: false },
            { name: "Water Purifier", href: "/mapform", current: false },
            {
              name: "Electrical Work",
              href: "/electricalwork",
              current: false,
            },
          ],
        },
      ],
    },
  ];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className="min-h-full z-10 sticky top-0 shadow-xl">
      <Disclosure as="nav" className="bg-gray-50">
        {({ open, close }) => (
          <>
            <div className="mx-auto max-w-7xl px-2 sm:px-2 lg:px-2">
              <div className="flex pt-1 h-16 items-center justify-between">
                {/* Logo */}
                <div className="flex items-center">
                  <Link to="/" className="flex-shrink-0 flex items-center ">
                    <img
                      className="flex h-24 w-32 rounded-md hover:scale-105 transition-transform duration-300 cursor-pointer"
                      src={orglogo}
                      alt="Your Company"
                    />
                  </Link>
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center">
                  <div className="ml-10 flex items-baseline space-x-4">
                    {navigation.map((item) =>
                      item.children ? (
                        <div key={item.name} className="relative" ref={menuRef}>
                          <button
                            onClick={toggleServicesMenu}
                            className={classNames(
                              "text-gray-900 hover:bg-blue-200 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-normal flex items-center",
                            )}
                          >
                            {item.name}
                            <ChevronDownIcon
                              className="ml-2 h-5 w-5"
                              aria-hidden="true"
                            />
                          </button>
                          {isServicesMenuOpen && (
                            <div className="absolute left-0 mt-9 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 border-gray-600 border-b-4">
                              <div
                                className="py-1"
                                role="menu"
                                aria-orientation="vertical"
                              >
                                {item.children.map((subItem) =>
                                  subItem.children ? (
                                    <div
                                      key={subItem.name}
                                      className="border-t border-gray-200 first:border-t-0"
                                    >
                                      <button
                                        onClick={() =>
                                          toggleCategory(subItem.name)
                                        }
                                        className="w-full text-left px-4 py-2 text-sm font-semibold text-gray-900 bg-gray-50 hover:bg-blue-200 flex justify-between items-center"
                                      >
                                        {subItem.name}
                                        <ChevronDownIcon
                                          className={`h-4 w-4 transform transition-transform ${openCategories[subItem.name] ? "rotate-180" : ""}`}
                                          aria-hidden="true"
                                        />
                                      </button>
                                      {openCategories[subItem.name] && (
                                        <div>
                                          {subItem.children.map(
                                            (subSubItem) => (
                                              <Link
                                                key={subSubItem.name}
                                                to={subSubItem.href}
                                                className="block px-4 py-3 text-sm text-gray-700 hover:bg-green-100 shadow-sm"
                                                role="menuitem"
                                                onClick={() => {
                                                  closeServicesMenu();
                                                  scrollToTop();
                                                }}
                                              >
                                                {subSubItem.name}
                                              </Link>
                                            ),
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <Link
                                      key={subItem.name}
                                      to={subItem.href}
                                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-green-100 shadow-sm"
                                      role="menuitem"
                                      onClick={() => {
                                        closeServicesMenu();
                                        scrollToTop();
                                      }}
                                    >
                                      {subItem.name}
                                    </Link>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-gray-200 text-gray-900"
                              : "text-gray-900 hover:bg-blue-200 hover:text-gray-900",
                            "px-3 py-2 rounded-md text-sm font-medium",
                          )}
                          aria-current={item.current ? "page" : undefined}
                          onClick={() => {
                            scrollToTop(); // Scroll to top on link click
                          }}
                        >
                          {item.name}
                        </Link>
                      ),
                    )}
                  </div>
                  {/* Book Now Button */}
                  <div className="flex items-center gap-3">
                    {/* Phone Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="blue"
                      class="size-6"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                        clip-rule="evenodd"
                      />
                    </svg>

                    {/* Phone Number */}
                    <a
                      href="tel:7870527000"
                      className="text-black text-lg font-semibold"
                    >
                      +91 7870527000
                    </a>

                    {/* WhatsApp Button */}
                  </div>
                </div>

                {/* Mobile Menu Button */}
                <div className="mr-2 flex md:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-gray-200 p-2 text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-200">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="md:hidden">
              <div className="space-y-1 px-2 pt-2 mt-2 pb-3 sm:px-3">
                <div className="flex justify-center"></div>{" "}
                {navigation.map((item) =>
                  item.children ? (
                    <Disclosure
                      key={item.name}
                      as="div"
                      // className={"h-24 scroll-auto overflow-x-auto"}
                    >
                      {({ open }) => (
                        <>
                          <Disclosure.Button className="w-full flex justify-between text-gray-900 hover:bg-white hover:text-gray-900 px-3 py-0.5 rounded-md text-base font-medium">
                            {item.name}
                            <ChevronDownIcon
                              className={`${
                                open ? "transform rotate-180" : ""
                              } h-5 w-5`}
                              aria-hidden="true"
                            />
                          </Disclosure.Button>
                          <Disclosure.Panel
                            className="space-y-2    h-52 scroll-auto overflow-x-auto
                      "
                          >
                            {item.children.map((subItem) =>
                              subItem.children ? (
                                <Disclosure key={subItem.name} as="div">
                                  {({ open }) => (
                                    <>
                                      <Disclosure.Button className="w-full flex justify-between text-gray-900 hover:bg-white hover:text-gray-900 px-3 py-0.5 rounded-md text-base font-medium">
                                        {subItem.name}
                                        <ChevronDownIcon
                                          className={`${open ? "transform rotate-180" : ""} h-5 w-5`}
                                          aria-hidden="true"
                                        />
                                      </Disclosure.Button>
                                      <Disclosure.Panel className="space-y-2 pl-4">
                                        {subItem.children.map((subSubItem) => (
                                          <Link
                                            key={subSubItem.name}
                                            to={subSubItem.href}
                                            className="block px-3 py-0.5 pl-7 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                                            onClick={() => {
                                              scrollToTop();
                                              close();
                                            }}
                                          >
                                            {subSubItem.name}
                                          </Link>
                                        ))}
                                      </Disclosure.Panel>
                                    </>
                                  )}
                                </Disclosure>
                              ) : (
                                <Link
                                  key={subItem.name}
                                  to={subItem.href}
                                  className="block px-3 py-2 rounded-md text-base font-medium"
                                  onClick={() => {
                                    scrollToTop();
                                    close();
                                  }}
                                >
                                  {subItem.name}
                                </Link>
                              ),
                            )}
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  ) : (
                    <Disclosure.Button
                      key={item.name}
                      className={`${
                        item.current
                          ? "bg-gray-100 text-gray-900"
                          : "text-gray-900 hover:bg-white hover:text-gray-900"
                      } block px-3 py-2 rounded-md text-base font-medium`}
                      // onClick={() => {
                      //   scrollToTop(); // Scroll to top when Home or About Us is clicked
                      //   close(); // Close the mobile menu after selecting the item
                      // }}
                    >
                      <Link
                        as={Link}
                        key={item.name}
                        to={item.href}
                        onClick={() => {
                          scrollToTop(); // Scroll to top when a subitem is clicked
                          close(); // Close the menu after selecting the subitem
                        }}
                      >
                        {item.name}
                      </Link>
                    </Disclosure.Button>
                  ),
                )}
                {/* Enquiry Free Button */}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
